import { render, staticRenderFns } from "./TransactionHistory_Tutor.vue?vue&type=template&id=86c28a3e&"
import script from "./TransactionHistory_Tutor.vue?vue&type=script&lang=js&"
export * from "./TransactionHistory_Tutor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports